import React, { useState, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import { debounce } from 'lodash';
import { portfolioTypeString } from '../../../utils/strings';

const PortfolioPicker = ({ onSelect,
                           text='Select Portfolio',
                           allowTypes = ['b', 's', 'm'] }, ...rest
                         ) => {
  const portfolios = useSelector(state => state.portfolios.items);
  const [open, setOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [selectedPortfolio, setSelectedPortfolio] = useState(null);

  const filteredPortfolios = useMemo(() => {
    return portfolios.filter(portfolio =>
      allowTypes.includes(portfolio.type) &&
      (!searchValue || portfolio.name.toLowerCase().includes(searchValue.toLowerCase()))
    );
  }, [portfolios, allowTypes, searchValue]);

  const handleSearch = useCallback(debounce((value) => {
    setSearchValue(value);
  }, 300), []);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSearchValue('');
  };

  const handleSelect = (portfolio) => {
    setSelectedPortfolio(portfolio);
    onSelect(portfolio);
    handleClose();
  };

  return (
    <div>
      <Button onClick={handleClickOpen} {...rest}>
        {text}
      </Button>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Select Portfolio</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Search Portfolios"
            type="text"
            fullWidth
            variant="outlined"
            onChange={(e) => handleSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <List>
            {filteredPortfolios.map((portfolio) => (
              <ListItem button key={portfolio.id} onClick={() => handleSelect(portfolio)}>
                <ListItemText
                  primary={portfolio.name}
                  secondary={portfolioTypeString(portfolio.type)}
                />
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PortfolioPicker;